export function changeLanguage(i18n, dayjs, language) {
  localStorage.setItem('currentLanguage', language);

  i18n?.changeLanguage(language);
  dayjs?.locale(language?.includes('en') ? 'en-gb' : 'ru');
}
